import { actionCreator } from 'utils/redux';
export const initLobby = actionCreator('INIT_LOBBY');
export const resetLobby = actionCreator('RESET_LOBBY');
